import React from "react";
import ProfileStore from "../Profile/ProfileStore";

export default class EventNotAvailable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Profile: ProfileStore.getState()
        }
    }

	render() {
		var notAvailableMessage = this.props.resources['PWS.Events.NotAvailableText'].replace("{0}", this.state.Profile.name);

		return (
			<div className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources['PWS.Events.NotAvailableTitle']}</div>
					<div className="description">{notAvailableMessage}</div>
				</div>
				<div id="publicPartiesList" className="section-wrapper clearfix">
					<div className="sectionButtons" style={{ textAlign: 'center', margin: '12px 0' }}>
						<button className="bookPartyBtn" onClick={this.props.backToList.bind(this)}>{this.props.resources['SiteMap:PWSEvents.Name.Text']}</button>
					</div>
				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/EventNotAvailable.js